/**
 * mock of unused code
 */

module.exports = {};
